// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./product-list/product-card/styles.scss
// module id = 945
// module chunks = 0